export const VALID_CHARACTERS = /[^a-zA-Z0-9\s\-_{}[\]()]/g;

export const removeSpecialCharacters = (text: string) => {
  return text.replace(VALID_CHARACTERS, '');
};
